module.exports = __webpack_public_path__ + "img/33_2024_08_23.c2137ed3.jpg";